import { createContext, useEffect, useState } from "react";

import { useNavigate } from "react-router-dom"

export const Context = createContext();

export const MainContext = ({ children }) => {

    const navigate = useNavigate();

    const [spaceActive, setSpaceActive] = useState(false);
    const [heroActive, setHeroActive] = useState(false);
    const [projectsActive, setProjectsActive] = useState(false);
    const [aboutActive, setAboutActive] = useState(false);
    const [menuActive, setMenuActive] = useState(false);

    // work
    const [workHeroActive, setWorkHeroActive] = useState(true);
    const [workInfoActive, setWorkInfoActive] = useState(false);
    const [workPreActive, setWorkPreActive] = useState(false);

    const callNextPage = () => {

        setTimeout(() => {
            if (heroActive) {
                setProjectsActive(true);
                setHeroActive(false);
            };

            if (projectsActive) {
                setAboutActive(true);
                setProjectsActive(false);
            };

            if (aboutActive) {
                setHeroActive(true);
                setAboutActive(false);
            }
        }, 1000);
    };

    useEffect(() => setHeroActive(true), []);

    const callSpace = () => {
        setSpaceActive(true);
        setTimeout(() => setSpaceActive(false), 1000);
    };

    const callMenu = () => {
        setMenuActive(!menuActive);
    };

    const callHero = () => {
        setHeroActive(true);
        setAboutActive(false);
        setProjectsActive(false);
        setMenuActive(false);
        navigate("/");
    };

    const callProjects = () => {
        setProjectsActive(true);
        setHeroActive(false);
        setAboutActive(false);
        setMenuActive(false);
        navigate("/");
    };

    const callAbout = () => {
        setAboutActive(true);
        setHeroActive(false);
        setProjectsActive(false);
        setMenuActive(false);
        navigate("/");
    };

    // work
    const callWorkNextPage = () => {
        if (workPreActive) {
            setWorkHeroActive(true);
            setWorkInfoActive(false);
            setWorkPreActive(false);
        };

        if (workHeroActive) {
            setWorkHeroActive(false);
            setWorkInfoActive(true);
            setWorkPreActive(false);
        };

        if (workInfoActive) {
            setWorkHeroActive(false);
            setWorkInfoActive(false);
            setWorkPreActive(true);
        }
    };


    const callOnlyWorkHero = () => {
        setWorkHeroActive(true);
        setWorkInfoActive(false);
        setWorkPreActive(false);
    }


    const globalStates = {
        callSpace,
        spaceActive,
        callMenu,
        menuActive,
        callNextPage,
        heroActive,
        projectsActive,
        aboutActive,
        callHero,
        callProjects,
        callAbout,

        //work
        workHeroActive,
        workInfoActive,
        workPreActive,
        callWorkNextPage,
        callOnlyWorkHero,
    };

    return <Context.Provider value={globalStates}>{children}</Context.Provider>
};